import LicenseAgreement from './LicenseAgreement';
export default LicenseAgreement;
